import styled from 'styled-components/macro'
import { Calendar } from 'react-date-range'

export const CalendarProxy = styled(Calendar)`
  & .rdrMonths {
    & .rdrMonth {
      & .rdrDays {
        & .rdrDay {
          & .rdrDayNumber {
            & span::after {
              content: '';
              background-color: black;
            }
          }
        }
      }
    }
  }
`
